// import store from '../../store';
import propsStore from '../../store/propsStore/propsStore';
import ApiaField from '../ApiaField';
import ApiaForm from '../ApiaForm';
import Field from '../constants/Field';
// import { setFileInputFromJSApi } from '../../store/JSApiSlice';
// import { jsonDecode } from '../../utils/util';
import { IApiaField } from '../types';

export interface IFileUploaderField extends IApiaField {
  getValue(): string | null;
  onChange(cb: (newValue: unknown) => unknown): unknown;
  setValue(): null;
}

export default class FileUploaderField
  extends ApiaField
  implements IFileUploaderField
{
  constructor(field: HTMLInputElement, form: ApiaForm) {
    super(field, form, [
      Field.PROPERTY_HIDE_DOC_PERMISSIONS,
      Field.PROPERTY_HIDE_DOC_METADATA,
      Field.PROPERTY_REQUIRED,
      Field.PROPERTY_DISABLED,
      Field.PROPERTY_READONLY,
      Field.PROPERTY_HIDE_DOC_UPLOAD,
      Field.PROPERTY_HIDE_DOC_DOWNLOAD,
      Field.PROPERTY_HIDE_DOC_ERASE,
      Field.PROPERTY_HIDE_DOC_LOCK,
      Field.PROPERTY_HIDE_DOC_SIGN,
      Field.PROPERTY_NO_MODIFY,
      Field.PROPERTY_NO_DOWNLOAD,
      Field.PROPERTY_NO_ERASE,
      Field.PROPERTY_NO_LOCK,
      Field.PROPERTY_ALLOW_EDITION,
      Field.PROPERTY_VISIBILITY_HIDDEN,
      Field.PROPERTY_FILE_PREVIEW,
      Field.PROPERTY_SIGNATURE_REQUIRED,
      Field.PROPERTY_DOCUMENT_SHOW_FOLD_TREE_BTN,
      Field.PROPERTY_DOCUMENT_SHOW_FOLD_TREE_STR,
      Field.PROPERTY_DOCUMENT_NO_ALLOW_DRAG_DROP,
      Field.PROPERTY_DOCUMENT_NO_SHOW_MODAL,
      Field.PROPERTY_DOCUMENT_SHOW_DESC,
      Field.PROPERTY_DOCUMENT_EXP_DATE,
      Field.PROPERTY_DOCUMENT_DNT_SHW_DOC_MON,
      Field.PROPERTY_DOCUMENT_COLLAPSE_PERM,
      Field.PROPERTY_DOCUMENT_COLLAPSE_META,
      Field.PROPERTY_DOCUMENT_COLLAPSE_FLD_STC,
    ]);
  }

  getValue(): string | null {
    // get value form store
    // if (this.checkFieldExistsInDocument(this.fldId)) {
    // }
    return null;
  }

  lastEmitedValue: unknown;

  onChange(cb: (newValue: unknown) => unknown) {
    propsStore.subscribe(this.fldId as string, (props) => {
      if (this.lastEmitedValue !== props?.value) {
        this.lastEmitedValue = props?.value;
        cb(props.value);
      }
    });
  }

  setValue(): null {
    if (this.checkFieldExistsInDocument(this.fldId) && this.fldType) {
      throw new Error(
        `Apia JSApi Error: The Field ${this.fldType} does not support this function`,
      );
    }
    return null;
  }
}
